import { Col, Form, Row, Select, Button, Spin, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import { TYPE_PAGE, VEHICLE_TYPE, LOCATION_TYPE, VEHICLE_CAPACITY, VEHICLE_CATEGORY } from '../../../constants';
import { ReactSVG } from 'react-svg';
import TagInput from '../../Elements/TagInput';
import AddressInput from '../../Inputs/AddressInput';

const initValuesForm = {
  region: 'Amsterdam',
  locationType: LOCATION_TYPE.HUB,
  vehicleType: VEHICLE_TYPE[0],
};

export const getVehicleEmoji = (vehicleCategory) => {
  switch (vehicleCategory) {
    case 'BIKE':
      return '🚲 ';
    case 'CAR':
      return '🚚 ';
    default:
      return '';
  }
};

const VehicleForm = ({ handleCancel, handleOk, vehicle, isModalOpen, isFetching, typePage = TYPE_PAGE.NEW }) => {
  const [formVehicle] = Form.useForm();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    if (vehicle) {
      formVehicle.setFieldsValue({ ...vehicle });
      setTypes(vehicle.capabilities);
    } else {
      formVehicle.resetFields();
      setTypes([]);
    }
  }, [formVehicle, isModalOpen, vehicle]);

  const onFinishForm = (values) => {
    const params = {
      vehicleType: values.vehicleType,
      //vehicleCategory: VEHICLE_CATEGORY[values.vehicleType],
      name: values.name,
      regions: values.regions,
      locationType: values.locationType,
      capabilities: types,
      startAddress: values.startAddress.address,
      startAddressLat: String(values.startAddress.latLng.lat),
      startAddressLng: String(values.startAddress.latLng.lng),
      endAddress: values.endAddress.address,
      endAddressLat: String(values.endAddress.latLng.lat),
      endAddressLng: String(values.endAddress.latLng.lng),
    };
    handleOk && handleOk(params);
  };

  const onCancel = () => {
    handleCancel && handleCancel();
  };

  const onOk = () => {
    formVehicle.submit();
  };

  return (
    <Spin spinning={isFetching}>
      <div className="VehicleForm">
        <Form
          form={formVehicle}
          scrollToFirstError
          layout="vertical"
          requiredMark={false}
          colon={false}
          className="FormContent"
          onFinish={onFinishForm}
          initialValues={initValuesForm}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Required' }]}>
                <Input placeholder="Name" size="large" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Location Type" name="locationType" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  options={Object.keys(LOCATION_TYPE).map((key) => ({ value: LOCATION_TYPE[key], label: key }))}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Region" name="regions" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  mode="multiple"
                  options={[
                    { label: 'Amsterdam', value: 'Amsterdam' },
                    { label: 'Den Haag', value: 'Den Haag' },
                    { label: 'Rotterdam', value: 'Rotterdam' },
                    { label: 'Utrecht', value: 'Utrecht' },
                    { label: 'Maastricht', value: 'Maastricht' },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Vehicle Type" name="vehicleType" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  options={VEHICLE_TYPE.map((v_type) => ({
                    value: v_type,
                    label:
                      getVehicleEmoji(VEHICLE_CATEGORY[v_type]) + v_type + ' - Capacity: ' + VEHICLE_CAPACITY[v_type],
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Capabilities" name="capabilities">
                <TagInput size="large" tags={types} onChange={(values) => setTypes(values)} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Start Address"
                name="startAddress"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                        return Promise.resolve();
                      }

                      if (isEmpty(value?.address)) {
                        return Promise.reject(new Error('Required'));
                      }

                      return Promise.reject(new Error('Invalid'));
                    },
                  },
                ]}
              >
                <AddressInput
                  size="large"
                  placeholder="Address"
                  onSelect={(value) => formVehicle.setFieldsValue({ startAddress: value })}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="End Address"
                name="endAddress"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                        return Promise.resolve();
                      }

                      if (isEmpty(value?.address)) {
                        return Promise.reject(new Error('Required'));
                      }

                      return Promise.reject(new Error('Invalid'));
                    },
                  },
                ]}
              >
                <AddressInput
                  size="large"
                  placeholder="Address"
                  onSelect={(value) => formVehicle.setFieldsValue({ endAddress: value })}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div className="FormFooter">
          <Button className="ButtonCancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button className="CreateButton ButtonPrimary" type="primary" onClick={onOk}>
            {vehicle && typePage === TYPE_PAGE.EDIT ? 'Edit' : 'Create'}
            <ReactSVG className="icon" src="/icons/done.svg" />
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default VehicleForm;
